import React, { useRef, useState } from "react";
import "./VendorSignup.css";
import { toast } from "react-toastify";

const VendorFormModal = ({ onClose }) => {
  const form = useRef();
  const [uploadedFiles, setUploadedFiles] = useState([]);

  const [formData, setFormData] = useState({
    vendor_name: "",
    vendor_address: "",
    vendor_number: "",
    service_type: ""
  });

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setUploadedFiles(files); // overwrite, not append
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();

    // Append form fields
    Object.entries(formData).forEach(([key, value]) => {
      data.append(key, value);
    });

    // Append files
    uploadedFiles.forEach((file) => {
      data.append("files", file); // "files" must match backend field
    });

    try {
      const res = await fetch("https://rcsbackend.onrender.com/send-vendor", {

        method: "POST",
        body: data
      });

      const result = await res.json();
      if (result.success) {
        toast.success("✅ Vendor application sent!");
        setUploadedFiles([]);
        setFormData({
          vendor_name: "",
          vendor_address: "",
          vendor_number: "",
          service_type: ""
        });
        onClose();
      } else {
        toast.error("❌ Submission failed.");
      }
    } catch (err) {
      console.error("Error submitting vendor form:", err);
      toast.error("❌ Could not send. Try again.");
    }
  };

  return (
<div className="modal-overlay">
  <div className="vendor-modal">
    <div className="modal-content">
    <h3>📝 Vendor Sign-Up</h3>
    <form ref={form} onSubmit={handleSubmit}>
      <input
        type="text"
        name="vendor_name"
        placeholder="Full Name"
        value={formData.vendor_name}
        onChange={(e) => setFormData({ ...formData, vendor_name: e.target.value })}
        required
      />
      <input
        type="text"
        name="vendor_address"
        placeholder="Address"
        value={formData.vendor_address}
        onChange={(e) => setFormData({ ...formData, vendor_address: e.target.value })}
        required
      />
      <input
        type="tel"
        name="vendor_number"
        placeholder="Vending Contact Number"
        value={formData.vendor_number}
        onChange={(e) => setFormData({ ...formData, vendor_number: e.target.value })}
        required
      />
<select
  name="service_type"
  value={formData.service_type}
  onChange={(e) => setFormData({ ...formData, service_type: e.target.value })}
  required
>
  <option value="">Select Service Type</option>
  <option value="Digicel">Digicel</option>
  <option value="Enet">Enet</option>
  <option value="GTT">GTT</option>
</select>

<label className="upload-label">
  Upload ID, TIN, or License (PDF/Image):
</label>
<input
  type="file"
  name="files"
  multiple
  onChange={handleFileChange}
/>


      <ul className="file-list">
        {uploadedFiles.map((file, idx) => (
          <li key={idx}>{file.name}</li>
        ))}
      </ul>

      <div className="button-group">
          <button type="submit">Submit</button>
          <button type="button" className="close-btn" onClick={onClose}>Cancel</button>
        </div>

    </form>
  </div>
</div>
</div>
  );
};

export default VendorFormModal;
